export const getAccounts = (resolve, reject, tokenId) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getcognitousers', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    }
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getAccounts response format error.');
      }
    } else {
      reject('getAccounts response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const deleteAccount = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/delaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('deleteAccount response format error.');
      }
    } else {
      reject('deleteAccount response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}